import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { notification } from 'antd';
import { usePut } from 'hooks';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { exportTemplateActions as actions } from 'reducers/exportTemplate/reducer';
import { exportTemplate } from 'services/api';
import { errorResToMessageArray } from './errorResToMessageArray';

const SuccessIcon = (
  <CheckCircleOutlined style={{ fontSize: 20, color: 'green' }} />
);
const ErrorIcon = (
  <CloseCircleOutlined style={{ fontSize: 20, color: 'red' }} />
);

export const useUpdateTemplateMutation = (
  _onRequestSuccess,
  _onRequestError
) => {
  const dispatch = useDispatch();

  const onRequestError = useCallback(
    res => {
      notification.open({
        icon: ErrorIcon,
        message: 'Error',
        description: (
          <div>
            Failed to update template.
            {errorResToMessageArray(res).map(err => (
              <p key={err} style={{ fontSize: 12, color: '#666' }}>
                {err}
              </p>
            ))}
          </div>
        ),
        placement: 'bottomLeft',
        duration: 8, // Seconds
      });
      _onRequestError?.();
    },
    [_onRequestError]
  );

  const onRequestSuccess = useCallback(
    res => {
      dispatch(actions.serverMutationOccurred());
      notification.open({
        icon: SuccessIcon,
        message: 'Success',
        description: 'Template updated successfully',
        placement: 'bottomLeft',
      });
      _onRequestSuccess?.(res);
    },
    [_onRequestSuccess, dispatch]
  );

  const [{ loading: updateLoading }, sendUpdate] = usePut({
    configuration: {
      onRequestSuccess,
      onRequestError,
    },
  });

  const triggerUpdate = useCallback(
    (templateId, payload) => {
      sendUpdate({
        url: exportTemplate(templateId),
        body: payload,
      });
    },
    [sendUpdate]
  );

  return {
    triggerUpdate,
    updateLoading,
  };
};
